import Commerce from '@chec/commerce.js';

// export const commerce = new Commerce(process.env.REACT_APP_CHEC_PUBLIC_KEY, true);
export const commerce = new Commerce('pk_test_250807816e649cfb6dec7160f2c0f21f311c558871cda', true);